function skillNames(employee) {
    return (employee.skills || []).map(name => String(name || '').trim()).filter(Boolean);
}

function positionName(employee) {
    return String(employee.position || employee.operational_position || '').trim();
}

function employeeFilterOptions(employees, field) {
    const values = [];
    employees.forEach(employee => {
        values.push(...(field === 'skills' ? skillNames(employee) : [positionName(employee)]));
    });
    return Array.from(new Set(values.filter(Boolean)))
        .sort((left, right) => left.localeCompare(right, 'ru'));
}

function employeeIsItr(employee) {
    if (typeof employee.multi_assignment_eligible === 'boolean') return employee.multi_assignment_eligible;
    return [employee.itr_building_ids, employee.itr_object_group_ids]
        .some(ids => Array.isArray(ids) && ids.length > 0);
}

function matchesEmployeeFilters(employee, skills, positions, itr = false) {
    return (!skills.length && !positions.length && !itr)
        || (itr && employeeIsItr(employee))
        || skillNames(employee).some(name => skills.includes(name))
        || positions.includes(positionName(employee));
}

function employeeSkillDescriptions(employees) {
    const descriptions = Object.create(null);
    employees.forEach(employee => {
        (employee.skill_details || []).forEach(skill => {
            const name = String(skill.name || '').trim();
            const description = String(skill.description || '').trim();
            if (name && description && !descriptions[name]) descriptions[name] = description;
        });
    });
    return descriptions;
}

module.exports = {employeeFilterOptions, matchesEmployeeFilters, employeeSkillDescriptions, employeeIsItr};
